import { useMemo } from 'react';

const useVideoLink = (code) => {
    const link = useMemo(() => `https://www.youtube.com/embed/${code}?hl=pt&cc_lang_pref=pt&cc_load_policy=1`, [code]);
    return link;
};

export default useVideoLink;
